// API related actions
export const FETCHING_ITEM_BUDGET = '@@toyota/FETCHING_ITEM_BUDGET';
export const FETCHED_ITEM_BUDGET = '@@toyota/FETCHED_ITEM_BUDGET';
export const FETCHED_ITEM_BUDGET_FAILED = '@@toyota/FETCHED_ITEM_BUDGET_FAILED';
export const ADDING_ITEM_BUDGET = '@@toyota/ADDING_ITEM_BUDGET';
export const ADDED_ITEM_BUDGET = '@@toyota/ADDED_ITEM_BUDGET';
export const ADDED_ITEM_BUDGET_FAILED = '@@toyota/ADDED_ITEM_BUDGET_FAILED';

// complementary actions
export const DELETE_ITEM_BUDGET = '@@toyota/DELETE_ITEM_BUDGET';
